module.exports = __webpack_public_path__ + "static/media/outlined-checkmark.a918a331.svg";